import React, { Component } from 'react';
import clickUser from '../ClicUserHOC';

export default function myS4CRedirect(ComposedComponent) {
  class MyS4CHOC extends Component {
    UNSAFE_componentWillMount() {
      if (!this.props.isAuthenticated) {
        this.props.history.push('/MyS4C/SignIn');
      }
    }

    UNSAFE_componentWillUpdate(nextProps) {
      if (!nextProps.isAuthenticated) {
        this.props.history.push('/MyS4C/SignIn');
      }
    }

    render() {
      return <ComposedComponent {...this.props} {...this.state} />;
    }
  }

  return clickUser(MyS4CHOC);
}
